import React from 'react';

type RedirectErrorWrapperProps = {
    url: string;
    redirect: boolean;
    children: React.ReactNode;
};

export const RedirectErrorWrapper: React.FC<RedirectErrorWrapperProps> = ({
    url,
    redirect,
    children,
}) => {
    if (redirect) window.location.href = url;
    return <>{children}</>;
};
